import { Icon } from '@testsigma/atoms';

const ModalIcon = () => (
  <div className='h-12 w-12 rounded-full bg-warning-50 flex items-center justify-center'>
    <Icon
      name='emergency-home'
      className='text-2xl text-warning-600 p-1 bg-warning-100 rounded-full'
    />
  </div>
);

export default ModalIcon;
